import { createUseStyles } from 'react-jss';

export const useBorrowAssetsStyle = createUseStyles({
    collateralAssetRoot: {
        position: 'relative',
    },
});
